import { MetricsKind } from "helpers/metrics/types";
import { RowComputeParams } from "./types";
import { sum } from "./sum";
import { safeParseFloat } from "lib/number";

export const IMU_PERCENTAGE = (params: RowComputeParams) => {
    const { mainRowNodes, getterParams, gridViewRef } = params;

    const retailValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.TOTAL_RETAIL,
        mainRowNodes
    );
    const costValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.TOTAL_COST,
        mainRowNodes
    );

    const totalRetail = sum(retailValues);
    const totalCost = sum(costValues);
    return safeParseFloat((totalRetail - totalCost) / totalRetail, 0) * 100;
};
